/**
 * Payment form adapters, by provider id (tracker item 38). The only place
 * outside an adapter folder that names the adapters, like the backend
 * composition root: adding a processor = one adapter folder + one line here.
 */
import { PaymentFormAdapter, PaymentFormAdapterRegistration } from './paymentFormAdapter';
import { squareRegistration } from './square/squarePaymentFormAdapter';
import { fakeRegistration } from './fake/fakePaymentFormAdapter';

const REGISTRY: PaymentFormAdapterRegistration[] = [squareRegistration, fakeRegistration];

/** A fresh adapter for the provider, or null when this app has no form for it. */
export function createPaymentFormAdapter(provider: string | null | undefined): PaymentFormAdapter | null {
  if (!provider) return null;
  const entry = REGISTRY.find((r) => r.provider.toUpperCase() === provider.toUpperCase());
  return entry ? entry.create() : null;
}

export function registeredPaymentFormProviders(): string[] {
  return REGISTRY.map((r) => r.provider);
}
